@if(loader){
<app-loader></app-loader>
}
<p-card [header]="isEdit ?  'Update User Information' : 'Create User Information'">
  <form [formGroup]="createUserForm">
    <div>
      <div class="field col-12 flex justify-content-between align-items-center">
        <div class="flex">
          <div>
            @if(isEdit){
            <p-button label="Update" severity="info" (click)="updateUser(createUserForm.value)"
              icon="pi pi-arrow-circle-up" size="small"></p-button>
            }@else {
            <p-button label="Save" class="p-button-outlined ml-2 " icon="pi pi-save" size="small"
              (click)="saveUser(createUserForm.value,isEdit)"></p-button>
            <p-button label="Reset" class="p-button-outlined ml-2" icon="pi pi-replay" severity="info" size="small"
              (onClick)="resetForm()"></p-button>
            }
          </div>
          <div>
            <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small"
              (click)="cancel()"></p-button>
          </div>
        </div>
        <div>
          <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
      </div>

    </div>


    <div class="grid m-5">
      <div class="col">

        <div class="field text-left">
          <label for="website" class="label-required display">User Name</label>
          <span class="p-float-label">
            <input pInputText formControlName="username" id="username"
              [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.username.errors }" [readonly]="isEdit" />
            <label for="username" class="text-base"></label>
          </span>
        </div>


        <div class="field text-left mt-5">
          <label for="website" class="label-required display">First Name</label>
          <span class="p-float-label">
            <input pInputText formControlName="firstname"
              [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.firstname.errors }" />
            <label for="firstname" class="text-base"></label>
          </span>
        </div>

        <div class="field text-left mt-5">
          <label for="website" class="label-required display">Email</label>
          <span class="p-float-label">
            <input pInputText formControlName="email"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !formControls.email.value}" />
            <label for="email" type="email" class="text-base"></label>
          </span>
        </div>
        @if(!isEdit){
        <div class="field text-left mt-5">
          <label class="label-required display">Password</label>
          <p-password formControlName="password" [toggleMask]="true" [feedback]="true" styleClass="w-full"
            inputStyleClass="w-full"
            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.password.errors }"></p-password>
        </div>
        <div class="field text-left mt-5">
          <label class="label-required display">Confirm Password</label>
          <p-password formControlName="confirmPassword" [toggleMask]="true" [feedback]="false" styleClass="w-full"
            inputStyleClass="w-full"
            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.confirmPassword.errors }"></p-password>
          <small *ngIf="submitted && formControls.confirmPassword.errors?.['mismatch']" class="text-red-500">
            Passwords do not match.
          </small>
        </div>
        } @else {
        <div class="field text-left mt-5">
          <p-button [label]="showChangePassword ? 'Cancel Password Change' : 'Change Password'" [text]="true"
            [icon]="showChangePassword ? 'pi pi-times' : 'pi pi-key'" size="small"
            (onClick)="toggleChangePassword()"></p-button>
        
          @if(showChangePassword){
          <div class="password-panel">
            <div class="field text-left mt-3">
              <label class="label-required display">Current Password</label>
              <p-password formControlName="oldPassword" [toggleMask]="true" [feedback]="false" styleClass="w-full"
                inputStyleClass="w-full"></p-password>
            </div>
            <div class="field text-left mt-3">
              <label class="label-required display">New Password</label>
              <p-password formControlName="newPassword" [toggleMask]="true" [feedback]="true" styleClass="w-full"
                inputStyleClass="w-full"></p-password>
            </div>
            <div class="field text-left mt-3">
              <label class="label-required display">Confirm New Password</label>
              <p-password formControlName="confirmNewPassword" [toggleMask]="true" [feedback]="false" styleClass="w-full"
                inputStyleClass="w-full"
                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.confirmNewPassword.errors }"></p-password>
              <small *ngIf="submitted && formControls.confirmNewPassword.errors?.['mismatch']" class="text-red-500">
                Passwords do not match.
              </small>
            </div>
          </div>
          }
        </div>
        }
        <div class="field text-left mt-5">
          <label for="website" >Employee</label>
          <div></div>
          <p-autoComplete formControlName="employee" (onSelect)="setEmployees($event)" [suggestions]="employeeDropdown"
            (completeMethod)="getEmployee()" field="displayName" placeholder="Search Employee"
            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.employee.errors }">
        
            <ng-template let-item pTemplate="item">
              <span>{{item.displayName}}</span>
            </ng-template>
          </p-autoComplete>
        
        </div>
      

      </div>

      <div class="col">

        <div class="field text-left">
          <div class="flex align-items-center" style="margin: 34px 0px 0px 0px;">
            <p-checkbox label="Active" formControlName="isactive" value="true" [binary]="true"></p-checkbox>
          </div>
        </div>


        <div class="field text-left mt-5">
          <label for="website" class="label-required display">Last Name</label>
          <span class="p-float-label">
            <input pInputText formControlName="lastname"
              [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.lastname.errors }" />
            <label for="lastname" class="text-base"></label>
          </span>
        </div>

        <div class="field text-left mt-5">
          <label for="website" class="label-required display">Roles</label>
          <div></div>
          <p-dropdown formControlName="userRole" styleClass="w-8" (onChange)="setUserRole($event)" [options]="roleList"
            value optionLabel="roleName" placeholder="Select Role"
            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.userRole.errors }"></p-dropdown>
        </div>


        <div class="field text-left mt-5">
          <label for="website" class="label-required display">{{unitLabel}}</label>
          <div></div>
          <p-autoComplete formControlName="warehouse" (onSelect)="setWarehouse($event)" [forceSelection]="true"
            [suggestions]="warehouseDropdown" (completeMethod)="getWarehouse()" field="warehouseName"
            placeholder="Search {{unitLabel}}"
            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouse.errors }">
            <ng-template let-item pTemplate="item">
              <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
            </ng-template>
          </p-autoComplete>
        </div>

        <div class="field text-left mt-5">
          <label>Mobile</label>
          <span class="p-float-label">
            <input pInputText formControlName="mobile"
              [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors }" />
            <small *ngIf="submitted && formControls.mobile.errors?.['pattern']" id="name-error"
              class="text-red-500">Invalid
              mobile number. Please enter 10-digit mobile number.</small>
          </span>
        </div>

      </div>

      <div class="col">
        <div class="field text-left mt-5">
          <label for="departmentName" class="label-required display">{{DeptLabel}}</label>
          <span class="p-float-label">
            <p-autoComplete [dropdown]="true" formControlName="department" [forceSelection]="true"
              [suggestions]="filterDepartments" field="departmentName" (completeMethod)="filterDepartment($event)"
              (onSelect)="SelectedDepartment($event)" placeholder="Search {{DeptLabel}}">

              <ng-template let-item pTemplate="item">
                <span>{{item.departmentCode}} - {{item.departmentName}}</span>
              </ng-template>
            </p-autoComplete>
          </span>
        </div>
      </div>

    </div>
  </form>


</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>